(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    // The cookie banner blocks YouTube until the visitor accepts marketing
    // cookies. It does that by swapping any youtube.com iframe for a notice of
    // its own — which reads "Accept marketing cookies to view this content" but
    // carries no way to accept, and replaces the poster on the way through, so
    // the visitor is left staring at a dead box with nothing to click.
    //
    // So ask first. If marketing is blocked, keep the poster where it is and
    // offer the one thing the app's own notice is missing: a button that opens
    // the cookie preferences. Consent itself is still the visitor's to give —
    // nothing here grants it for them, or routes around the block.
    //
    // Ask Consentmo, not the cookie. The consent cookie outlives the region it
    // was set in: a visitor who once refused and now browses from somewhere the
    // banner doesn't apply (the Philippines, say) still carries "marketing" in
    // it, yet Consentmo blocks nothing there and has no preferences box to
    // offer. Reading the cookie showed that visitor a notice for a block that
    // wasn't happening, with a button that could never open. marketingAllowed()
    // weighs the saved choice against the visitor's region the same way the
    // blocker does.
    function marketingBlocked() {
      var sdk = window.Consentmo;
      if (sdk && typeof sdk.marketingAllowed === 'function') {
        try {
          return !sdk.marketingAllowed();
        } catch (e) {}
      }
      // Consentmo hasn't loaded yet. Fall back to the saved choice, so an early
      // click never slips a YouTube embed past someone who refused.
      var match = document.cookie.match(/(?:^|;\s*)cookieconsent_preferences_disabled=([^;]*)/);
      if (!match) return false;
      return decodeURIComponent(match[1]).split(',').indexOf('marketing') !== -1;
    }

    function canOpenPreferences() {
      var sdk = window.Consentmo;
      return (
        !!(sdk && typeof sdk.openDialog === 'function') ||
        typeof window.openCookieWidgetPopup === 'function'
      );
    }

    function watchUrl(facade) {
      var id = encodeURIComponent(facade.getAttribute('data-youtube-id') || '');
      return facade.hasAttribute('data-youtube-playlist')
        ? 'https://www.youtube.com/playlist?list=' + id
        : 'https://www.youtube.com/watch?v=' + id;
    }

    // The box renders into the app's shadow root and loads on demand, so it can
    // take a second to appear.
    function preferencesOpened() {
      var root = document.querySelector('.csm-cmp-root');
      var scope = root && root.shadowRoot;
      var dialog = scope && scope.querySelector('[role="dialog"]');
      return !!(dialog && dialog.getClientRects().length);
    }

    function openPreferences(button) {
      var notice = button.closest('.page-video-block__notice');
      var opened = false;
      function onOpened() {
        opened = true;
      }
      document.addEventListener('consentmo:dialogOpened', onOpened);

      var sdk = window.Consentmo;
      if (sdk && typeof sdk.openDialog === 'function') sdk.openDialog('preferences');
      else window.openCookieWidgetPopup();

      // Consentmo refuses to open the box for visitors outside the regions it
      // targets. If it never shows, don't leave a dead button — point to the
      // video on YouTube itself. That plays on youtube.com under YouTube's own
      // terms, so nothing here routes around the block on this page.
      var started = Date.now();
      var timer = setInterval(function () {
        if (!opened && !preferencesOpened() && Date.now() - started < 3000) return;
        clearInterval(timer);
        document.removeEventListener('consentmo:dialogOpened', onOpened);
        if (opened || preferencesOpened()) return;

        if (!notice || notice.querySelector('.page-video-block__fallback')) return;
        var block = notice.parentNode;
        var facade = block && block.querySelector('.page-video-block__facade');
        if (!facade) return;

        var fallback = document.createElement('p');
        fallback.className = 'page-video-block__fallback';
        fallback.appendChild(document.createTextNode("Cookie settings couldn't open here. "));
        var link = document.createElement('a');
        link.href = watchUrl(facade);
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Watch this video on YouTube';
        fallback.appendChild(link);
        fallback.appendChild(document.createTextNode(' instead.'));
        notice.appendChild(fallback);
      }, 250);
    }

    function showNotice(facade) {
      var block = facade.parentNode;
      if (!block || block.querySelector('.page-video-block__notice')) return;

      var notice = document.createElement('div');
      notice.className = 'page-video-block__notice';
      notice.setAttribute('role', 'status');

      var text = document.createElement('p');
      text.textContent =
        'This video is hosted on YouTube, which stays blocked until you accept marketing cookies.';
      notice.appendChild(text);

      if (canOpenPreferences()) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'page-video-block__consent';
        button.textContent = 'Manage cookie preferences';
        notice.appendChild(button);
      }

      block.appendChild(notice);
      var focusable = notice.querySelector('button');
      if (focusable) focusable.focus();
    }

    function play(facade) {
      var id = facade.getAttribute('data-youtube-id');
      if (!id) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'page-video-block__iframe';
      // Playlists embed through the videoseries endpoint; single videos by id.
      iframe.src = facade.hasAttribute('data-youtube-playlist')
        ? 'https://www.youtube.com/embed/videoseries?list=' + encodeURIComponent(id) + '&autoplay=1'
        : 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = facade.getAttribute('aria-label') || 'YouTube video';

      var stale = facade.parentNode.querySelector('.page-video-block__notice');
      if (stale) stale.remove();

      facade.parentNode.replaceChild(iframe, facade);
      iframe.focus();
    }

    // One delegated listener covers every instance of this block on the page.
    document.addEventListener('click', function (event) {
      var node = event.target;
      if (!node || !node.closest) return;

      var consent = node.closest('.page-video-block__consent');
      if (consent) {
        if (canOpenPreferences()) openPreferences(consent);
        return;
      }

      var facade = node.closest('.page-video-block__facade');
      if (!facade) return;

      if (marketingBlocked()) showNotice(facade);
      else play(facade);
    });

    // Once the visitor accepts marketing in the box, play the video they asked
    // for, rather than making them find it and click it again.
    document.addEventListener('consentmoSignal', function () {
      if (marketingBlocked()) return;
      var notices = document.querySelectorAll('.page-video-block__notice');
      for (var i = 0; i < notices.length; i++) {
        var facade = notices[i].parentNode.querySelector('.page-video-block__facade');
        if (facade) play(facade);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["whl-video"] && !Shopify.designMode) return;
  try {
    class WhlVideo extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.whl-video__poster');
      const embed = this.dataset.embed;
      if (!button || !embed) return;
      button.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.title = button.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        button.replaceWith(iframe);
        iframe.focus();
      }, { once: true });
    }
  }
  if (!customElements.get('whl-video')) customElements.define('whl-video', WhlVideo);
  } catch(e) { console.error(e); }
})();

})();
